<template>
  <v-container>
    <v-row no-gutters align="center" justify="center">
      <v-col cols="12" sm="12" md="8">
        <div class="d-flex align-center">
          <v-tooltip right content-class="arrow tooltip-right" color="black">
            <template v-slot:activator="{on, attrs}">
              <v-btn x-small v-bind="attrs" v-on="on" icon>
                <v-btn icon @click="cancel" color="accent">
                  <v-icon x-large>mdi-chevron-left</v-icon></v-btn
                >
              </v-btn>
            </template>
            <span class="tooltip-text">Voltar para lista de usuários</span>
          </v-tooltip>
          <span
            :class="
              $vuetify.breakpoint.name == 'xs'
                ? 'pl-2 title-style-mobile'
                : 'pl-2 title-style'
            "
          >
            Adicionar usuário</span
          >
        </div>
        <p class="subtitle-style">
          Crie um novo usuário para acessar o AlertaDis.
        </p>
        <br />

        <span class="subtitle-style">Dados do novo usuário</span>
        <p class="subtitle-style-2">Todos os campos são obrigatórios.</p>
        <v-form ref="form" lazy-validation>
          <div class="form-input-group">
            <v-text-field
              class="text-field"
              id="name"
              v-model="user.name"
              :rules="[rulesName]"
              color="accent lighten-1"
              background-color="secondary base"
              outlined
              required
              placeholder="Informe seu nome"
            />
            <label for="name">Nome</label>
          </div>
          <div class="form-input-group">
            <v-text-field
              class="text-field"
              id="email"
              v-model="user.email"
              color="accent lighten-1"
              background-color="secondary base"
              outlined
              :rules="[rulesEmail]"
              required
              placeholder="Informe o e-mail corporativo"
            />
            <label for="email">E-mail</label>
          </div>
          <div class="form-input-group" v-if="isDominioCopel">
            <v-text-field
              class="text-field"
              id="matricula"
              v-model="user.originalid"
              :rules="[rulesMatricula]"
              color="accent lighten-1"
              background-color="secondary base"
              outlined
              required
              placeholder="Informe a matrícula"
            />
            <label for="matricula">Matrícula</label>
          </div>
          <div class="form-input-group">
            <v-select
              class="text-field"
              outlined
              color="accent"
              v-model="user.departmentId"
              placeholder="Selecione o setor"
              background-color="secondary"
              item-color="accent"
              :items="sectors"
              item-text="name"
              item-value="id"
              :rules="[rulesSector]"
            ></v-select>
            <label for="setor">Setor</label>
          </div>

          <div>
            <span class="switch-style-title">Status</span>
            <p class="switch-style-subtitle">
              Define se o usuário está com permissão para acessar o AlertaDIS
            </p>
            <v-switch
              v-model="user.active"
              :label="user.active ? 'Ativo' : 'Inativo'"
              color="success"
              inset
            ></v-switch>
          </div>
        </v-form>
        <div v-if="isSuperAdmin">
          <span class="switch-style-title">Administrador</span>
          <p class="switch-style-subtitle">
            O administrador poderá gerenciar usuários.
          </p>
          <v-switch
            v-model="user.admin"
            :label="user.admin ? 'Ativo' : 'Inativo'"
            color="success"
            inset
          ></v-switch>
        </div>
        <v-row no-gutters align="center">
          <v-col
            class="d-flex align-center"
            v-if="
              $vuetify.breakpoint.name == 'sm' ||
              $vuetify.breakpoint.name == 'md' ||
              $vuetify.breakpoint.name == 'lg' ||
              $vuetify.breakpoint.name == 'xl'
            "
          >
            <v-btn
              id="btn-add"
              color="accent lighten-1"
              @click="addUser"
              :loading="loading"
              large
            >
              <span>Adicionar</span>
            </v-btn>
            <div class="pl-10">
              <v-btn
                id="btn-clean"
                outlined
                color="accent lighten-1"
                large
                @click="clearFilter"
              >
                <span>Limpar formulário</span>
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.name == 'xs'" cols="12">
            <v-btn
              id="btn-add"
              color="accent lighten-1"
              :loading="loading"
              @click="addUser"
              large
            >
              <span>Adicionar</span>
            </v-btn>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.name == 'xs'" class="pt-5 mr-6">
            <v-btn
              id="btn-clean"
              outlined
              color="accent lighten-1"
              large
              @click="clearFilter"
            >
              <span>Limpar formulário</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UserSevice from "@/api/rest-administrative/user.service";
import {snackbar} from '@/core/controller/snackbar_controller';
import {mapGetters} from 'vuex';

export default {
  props: {
    departaments: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  mounted() {
    this.sectors = [...this.departaments];
    this.sectors.shift();
  },
  data: () => ({
    user: {
      acronym: '',
      active: true,
      admin: false,
      departmentId: null,
      email: '',
      name: null,
      observation: {},
      originalid: '',
      password: 'changeme1234',
    },
    loading: false,
    sectors: [],
  }),
  computed: {
    ...mapGetters(['currentUser']),
    rulesName() {
      if (!this.user.name) {
        return 'Informe o nome completo do usuário.';
      }
      if (
        !!this.user.name.match(
          /^[A-ZÀ-Ÿ][A-zÀ-ÿ']+\s([A-zÀ-ÿ']\s?)*[A-ZÀ-Ÿ][A-zÀ-ÿ']+$/,
        ) == false
      ) {
        return 'Informe o nome e sobrenome.';
      }

      return true;
    },

    rulesEmail() {
      if (!this.user.email) {
        return 'Informe o e-mail corporativo do usuário.';
      }
      if (/.+@.+\..+/.test(this.user.email) == false) {
        return 'Este e-mail é inválido. Informe o seu e-mail no formato exemplo@exemplo.com.';
      }
      if (
        /^\w+([-+.']\w+)*@?(simepar.br|copel.com|jointecnologia.com.br)$/.test(
          this.user.email,
        ) == false
      ) {
        return 'O e-mail deve pertencer ao Simepar ou a Copel.';
      }

      return true;
    },

    rulesMatricula() {
      if (!this.user.originalid) {
        return 'Informe uma mátricula.';
      }

      if (/^[A-Z]{1}[0-9]{6}$/.test(this.user.originalid) == false) {
        return 'Informe uma mátricula válida.';
      }
      return true;
    },

    rulesSector() {
      if (!this.user.departmentId) {
        return 'Selecione o setor do novo usuário.';
      }
      return true;
    },
    isDominioCopel() {
      const result = this.user.email.substring(
        this.user.email.indexOf('@') + 1,
      );

      if (result == 'copel.com') {
        return true;
      }
      return false;
    },
    isSuperAdmin() {
      return this.currentUser.attributes.roles.includes('AlertaDIS_SUPER_USER');
    },
  },
  watch: {
    'user.name'() {
      this.user.name = this.user.name
        .toLowerCase()
        .replace(/(?:^|\s)\S/g, function (capitalize) {
          return capitalize.toUpperCase();
        });
    },
    'user.originalid'() {
      this.user.originalid = this.user.originalid.toUpperCase();
    },
  },

  methods: {
    docStates(docState) {
      this.$emit('docStates', docState);
    },

    clearFilter() {
      this.user.name = '';
      this.user.email = '';
      this.user.originalid = '';
      this.user.departmentId = '';
      this.user.active = true;
      this.user.admin = false;
      this.$refs.form.resetValidation();
    },
    async addUser() {
      try {
        if (this.$refs.form.validate()) {
          this.loading = true;
          await UserSevice.postUser(this.user);
          this.$emit('alertUser', true, this.user.email, 'add');
          this.docStates('user');
          this.loading = false;
        }
      } catch (error) {
        snackbar.show({
          type: 'error',
          title: error.title,
          message: error.message,
          timeout: 7000,
        });
      } finally {
        this.loading = false;
      }
    },

    cancel() {
      this.$emit('alertUser', false);
      this.$emit('docStates', 'user');
    },
  },
};
</script>

<style scoped>
label {
  order: -1;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--v-primary-base);
}
.v-input:focus-within + label {
  color: var(--v-accent-lighten1) !important;
}
.form-input-group {
  display: flex;
  flex-direction: column;
  top: 22px;
}

.text-field {
  border-radius: 8px;
}
.title-style {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 46px;
}

.title-style-mobile {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 33px;
  letter-spacing: 0.25px;
}

.subtitle-style {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */

  letter-spacing: 0.15px;
}
.subtitle-style-2 {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.1px;
  color: var(--v-primary-darken1) !important;
}

.switch-style-title {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: var(--v-primary-base) !important;
}

.switch-style-subtitle {
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--v-primary-darken1) !important;
  letter-spacing: 0.4px;
}

#btn-add {
  width: 106px;
  text-transform: none;
  height: 50px;
  border-radius: 8px;
  padding: 16px 20px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}
#btn-clean {
  text-transform: none;
  width: 165px;
  height: 50px;
  border-radius: 8px;
  font-family: 'Manrope';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}
</style>
